export default __webpack_public_path__ + "static/media/jett_new.f3634249.png";